import type { Product } from '~/core/entities/strapi/Product';
import type { CartProduct } from '~/services/Cart/types';
export const useCartStore = defineStore('cart', {
  state: () => ({ products: [] as CartProduct<Product>[] }),
  actions: {
    add(product: Product, quantity = 1) {
      if (!Number.isFinite(product.price) || product.price < 0 || !Number.isFinite(quantity))
        return;
      const amount = Math.min(99, Math.max(1, Math.floor(quantity)));
      const item = this.products.find((item) => item.product.id === product.id);
      if (item) {
        item.quantity = Math.min(99, item.quantity + amount);
        item.product = product;
      } else this.products.push({ product, quantity: amount });
    },
    setQuantity(id: number, quantity: number) {
      if (!Number.isFinite(quantity)) return;
      const item = this.products.find((item) => item.product.id === id);
      if (item) item.quantity = Math.min(99, Math.max(1, Math.floor(quantity)));
    },
    remove(id: number) {
      this.products = this.products.filter((item) => item.product.id !== id);
    },
    clear() {
      this.products = [];
    },
  },
});
